import _ from "lodash";
import { useEffect, useState, useMemo, useRef } from "react";
import useItems from "./useItems";
import useLeadInfo from "./useLeadInfo";
import { saveItemsToSession } from "../../shoppingsite/utils";
import { fetchOrderDetailFromLeadId } from "../../../utils/signAgreementDocument";
import { updateLeadActivity } from "../../../hooks/updateLeadActivity";
import { monthlySMSQuotaFunction } from "../../../utils/monthlySMSQuota";
import { getPlanForDevices } from "../../../utils/planLadder";

// import { updateLeadActivity } from "../../../hooks/updateLeadActivity";

// The canonical empty selections. Module level so "accept recommendation" can
// reset to a known-clean slate, and so a restored session can be merged onto a
// complete shape instead of replacing it.
const EMPTY_VALUES = {
  Kiosk: 0,
  Kiozzk: 0,
  Computer: 0,
  // Customer-supplied hardware. Modelled the same way as Computer: a real
  // selection priced at $0, so the order records what the customer is
  // actually running rather than showing nothing at all.
  OwnTablet: 0,
  OwnTerminal: 0,
  SmartCheckout: 0,
  ReceiptPrinter: 0,
  CashdrawerSmall: 0,
  CashdrawerBig: 0,
  AriesStand: 0,
  MobileApp: false,
  Website: false,
  EmailMarketing: false,
};

const EMPTY_ADDITIONAL_VALUES = {
  SmartCheckout: 0,
  Kiozzk: 0,
  Computer: 0,
  OwnTablet: 0,
  OwnTerminal: 0,
  ReceiptPrinter: 0,
  CashdrawerSmall: 0,
  CashdrawerBig: 0,
  AriesStand: 0,
  MobileApp: false,
  Website: false,
  EmailMarketing: false,
};

const useDeviceCounter = (
  leadId,
  loggedIn,
  proceedToLeadInfo,
  setGettingOrderInfo
) => {
  [
    {
      "Growthzilla Kiozzk Tablet": 2,
      "Growthzilla Cloud Receipt Printer": 3,
      "Large CashDrawer": 3,
      "Small CashDrawer": 3,
      "Aries8/Aries6 Stand": 3,
      "Pax Aries 8 Checkout Terminal with Stand": 3,
    },
  ];

  const currentUser = JSON.parse(sessionStorage.getItem("user"));

  const initialCartItemsForAcceptModal = {
    "Growthzilla Kiozzk Tablet": 0,
    "Growthzilla Cloud Receipt Printer": 0,
    "Large CashDrawer": 0,
    "Small CashDrawer": 0,
    "Aries8/Aries6 Stand": 0,
    "Pax Aries 8 Checkout Terminal with Stand": 0,
  };

  let initialValues = { ...EMPTY_VALUES };
  let initialAdditionalValues = { ...EMPTY_ADDITIONAL_VALUES };
  if (currentUser?.id) {
    const values = JSON.parse(
      sessionStorage.getItem(`values-${currentUser && currentUser?.id}`)
    );
    if (values) {
      // Merged onto the blanks rather than replacing them: a session saved
      // before a key existed would otherwise restore it as undefined, and
      // `undefined + 0` turns the whole setup fee into NaN.
      initialValues = { ...EMPTY_VALUES, ...values.openValues };
      initialAdditionalValues = {
        ...EMPTY_ADDITIONAL_VALUES,
        ...values.openAdditionalValues,
      };
    }
  }
  const [openValues, setValues] = useState(initialValues);
  const [openAdditionalValues, setAdditionalValues] = useState(
    initialAdditionalValues
  );
  const [initialCartItems, setInitialCartItems] = useState(
    initialCartItemsForAcceptModal
  );

  const [equipmentPrice, setEquipmentPrice] = useState({
    SmartCheckout: 499,
    Kiozzk: 249,
    Computer: 0,
    // Customer already owns these, so nothing is charged for them.
    OwnTablet: 0,
    OwnTerminal: 0,
    ReceiptPrinter: 249,
    CashdrawerSmall: 99,
    CashdrawerBig: 99,
    AriesStand: 49,
    MobileApp: 50,
    Website: 50,
    EmailMarketing: 19,
  });

  const [qualifyingPlanPrice, setQualifyingPlanPrice] = useState(0);
  const [qualifyingEquipmentPrice, setQualifyingEquipmentPrice] = useState(0);
  const [equipDiscount, setEquipmentDiscount] = useState(0);
  // "" for a flat dollar amount, "Percentage" when equipDiscount is a percent
  // of the equipment total. Resolve with resolveEquipDiscount before using it
  // as money — the raw number is ambiguous on its own.
  const [equipDiscountType, setEquipDiscountType] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [equipmentsFilledFromOrder, setEquipmentsFilledFromOrder] =
    useState(false);

  const [planPermDiscount, setPermanentDiscount] = useState(0);
  const [planTempDiscount, setTemporaryDiscount] = useState(0);
  const [tempDiscountExpiryDate, setTempDiscountExpiryDate] = useState("");
  const [monthlySMSQuota, setMonthlySMSQuota] = useState(0);
  // Records whether Proma supplied a quota for this lead. A ref rather than
  // state because the plan-price effect below has to read it without being
  // re-run by it, and it must be readable before the next render commits.
  const promaSMSQuotaRef = useRef(null);
  const [priceAdd1KSMS, setPriceAdd1KSMS] = useState(0);
  const [installments, setInstallments] = useState(0);
  const [invalidLeadInfo, setInvalidLeadInfo] = useState(false);
  const [businessNameFromLeadInfo, setBusinessNameFromLeadInfo] = useState("");
  const [uzeliOrderFromDb, setUzeliOrderFromDb] = useState(null);
  // const [gettingOrderInfo, setGettingOrderInfo] = useState(false);
  // const [salesAgent, setSalesAgent] = use;
  const [minimumForInstallments, setMinimumForInstallments] = useState(0);

  const [growthzillaSignee, setGrowthzillaSignee] = useState("");
  const [salesAgent, setSalesAgent] = useState("");
  const [leadIdFromInfo, setleadIdFromInfo] = useState("");
  const [oldOrderToState, setOldOrderToState] = useState(false);

  const { getLeadInfo, loading: gettingLeadInfo } = useLeadInfo();

  const updateLeads = async (leadId, businessName) => {
    const leadID = leadId;
    const data = {
      id: leadID,
      leadActivity: "User Logged In",
      businessName: businessName,
    };
    updateLeadActivity(data);
  };

  useEffect(() => {
    if (leadId && loggedIn?.id) {
      // console.log({ formDeviceCounter: leadId });
      // let tempAdditionalValues = {};
      // let tempEquipmentPrice = {};
      // eslint-disable-next-line no-unused-vars

      const updateCount = async () => {
        const leadInfo = await getLeadInfo(leadId);
        console.log({ leadInfo });

        if (leadInfo?.error) {
          setInvalidLeadInfo(true);
        } else {
          if (Object.keys(leadInfo?.formInfo)) {
            saveItemsToSession(`formState_${loggedIn?.id}`, leadInfo?.formInfo);
          }
          if (leadInfo?.leadId) {
            setleadIdFromInfo(leadInfo?.leadId);
            saveItemsToSession("leadIdFromInfo", leadInfo?.leadId);
          }

          if (leadInfo?.orderId) {
            // setleadIdFromInfo(leadInfo?.leadId);
            saveItemsToSession("uzeliOrderId", leadInfo?.orderId);
          }

          if (leadInfo?.businessName) {
            setBusinessNameFromLeadInfo(leadInfo?.businessName);
            saveItemsToSession(
              "businessNameFromLeadInfo",
              leadInfo?.businessName
            );
          }
          if (!uzeliOrderFromDb?.orderId) {
            updateLeads(leadInfo?.leadId, leadInfo?.businessName);
          }
          setAdditionalValues({
            ...openAdditionalValues,
            // ...tempAdditionalValues,
          });

          setEquipmentPrice({
            ...equipmentPrice,
            // ...tempEquipmentPrice,
          });

          if (
            leadInfo?.equipments?.length &&
            Object.keys(leadInfo?.equipments[0]).length > 0
          ) {
            setInitialCartItems(leadInfo?.equipments[0]);
          }
          setQualifyingPlanPrice(leadInfo?.qualifyingPlanPrice);
          setQualifyingEquipmentPrice(leadInfo?.qualifyingEquipmentPrice);
          setEquipmentDiscount(leadInfo?.equipDiscount);
          setEquipDiscountType(leadInfo?.equipDiscountType ?? "");
          setInstallments(leadInfo?.installments);
          setMinimumForInstallments(leadInfo?.minimumForInstallments);

          setPermanentDiscount(leadInfo?.planPermDiscount);
          setTemporaryDiscount(leadInfo?.planTempDiscount);
          setTempDiscountExpiryDate(leadInfo?.tempDiscountExpiryDate);
          promaSMSQuotaRef.current = leadInfo?.monthlySMSQuota ?? null;
          setMonthlySMSQuota(leadInfo?.monthlySMSQuota);
          setPriceAdd1KSMS(leadInfo?.priceAdd1KSMS);
          console.log("growthzillaSignee:" + leadInfo?.growthzillaSignee);
          setGrowthzillaSignee(leadInfo?.growthzillaSignee);
          setSalesAgent(leadInfo?.salesAgent);
          if (leadInfo?.growthzillaSignee) {
            saveItemsToSession(
              "GrowthzillaSignee",
              leadInfo?.growthzillaSignee
            );
          }
          if (leadInfo?.salesAgent) {
            saveItemsToSession("Sales Agent", leadInfo?.salesAgent);
          }
          // const totalCount = leadInfo?.equipments?.reduce(
          //   (acc, item) => acc + item.quantity,
          //   0
          // );

          // if (totalCount > 0) {
          //   setEquipmentsFilledFromOrder(true);
          //   setCurrentPage(6);
          // }
        }
      };

      const setOldOrderData = async () => {
        await updateCount();
        populateCartItems();
      };

      const getOrderDetail = async () => {
        const orderDetail = await fetchOrderDetailFromLeadId(leadId);
        if (orderDetail?.orderId) {
          updateLeads(orderDetail?.leadId, orderDetail?.businessName);
        }
        setUzeliOrderFromDb(orderDetail);
        setGettingOrderInfo(false);
      };

      if (proceedToLeadInfo) {
        updateCount();
      } else if (oldOrderToState) {
        setOldOrderData();
      } else {
        getOrderDetail();
      }
    }
  }, [leadId, loggedIn, oldOrderToState, proceedToLeadInfo]);

  // console.log({
  //   proceedToLeadInfo,
  //   oldOrderToState,
  //   gettingLeadInfo,
  //   initialCartItems,
  // });

  useEffect(() => {
    // console.log("I should populate the items");
    if (oldOrderToState && Object.keys(initialCartItems ?? {})?.length) {
      // console.log("I should populate the items");
      // console.log({  });
      populateCartItems();
      // setOldOrderToState(false);
    }
  }, [initialCartItems]);

  const [uzeliItems, setItems] = useState([]);

  const toggleSwitch = (text) => {
    // Toggle main value
    setValues((prev) => ({
      ...prev,
      // Coerced because a session saved before a key existed restores it as
      // undefined, and `undefined === 0` is false — the first click on a newly
      // added switch would otherwise set 0 and appear to do nothing.
      [text]: (Number(prev[text]) || 0) === 0 ? 1 : 0,
    }));

    // The Aries stand used to be toggled alongside Smart Checkout here. It is
    // no longer sold separately — the terminal is "Pax Aries 8 Checkout
    // Terminal with Stand" — and nothing in the UI could ever clear it again:
    // SixthPage has no stand incrementor and StandWarning, the only component
    // with decrementValue("AriesStand"), is commented out in Document.jsx. It
    // was also a toggle rather than a mirror, so an order that already carried
    // a stand got it removed on select and re-added on deselect.
  };

  const enable = (text) => setValues({ ...openValues, [text]: 1 });
  const disable = (texts) => {
    // texts = ['Kiosk','Computer']
    const toChange = texts.map((e) => ({ [e]: 0 }));
    // toChange = [{'Kiosk':0},{'Computer':0}]
    let changePairs = {};
    toChange.forEach((e) => {
      changePairs = _.extend(changePairs, { ...e });
    });
    // changePairs = {
    //   'Kiosk':0,
    // } 'Computer':0

    setValues({ ...openValues, ...changePairs });
  };
  // console.log({ openAdditionalValues });
  useEffect(() => {
    if (!openValues.Computer && !openValues.Kiozzk) {
      setValues({ ...openValues, SmartCheckout: 0 });
    }
  }, [openValues?.Kiosk, openValues?.Kiozzk]);

  // Clears a stand that is already stranded on a saved session or a restored
  // order. Removing the toggle above stops new ones appearing, but existing
  // carts would keep charging $49 for an item with no control to remove it.
  useEffect(() => {
    if (Number(openAdditionalValues?.AriesStand) > 0) {
      setAdditionalValues((prev) => ({ ...prev, AriesStand: 0 }));
    }
  }, [openAdditionalValues?.AriesStand]);

  const [currentPage, setCurrentPage] = useState(1);

  const incrementPage = () => setCurrentPage(currentPage + 1);
  const decrementPage = () => setCurrentPage(currentPage - 1);

  const totalKiozzkCount = useMemo(() => {
    return (
      openValues?.Kiosk + openValues?.Kiozzk + openAdditionalValues?.Kiozzk
    );
  }, [openValues, openAdditionalValues]);

  const totalSmartCheckout = useMemo(() => {
    return openValues?.SmartCheckout + openAdditionalValues?.SmartCheckout;
  }, [openValues, openAdditionalValues]);

  const totalReceiptPrinter = useMemo(() => {
    return openValues?.ReceiptPrinter + openAdditionalValues?.ReceiptPrinter;
  }, [openValues, openAdditionalValues]);
  const totalCashDrawer = useMemo(() => {
    return (
      openValues?.CashdrawerSmall +
      openValues?.CashdrawerBig +
      openAdditionalValues?.CashdrawerSmall +
      openAdditionalValues?.CashdrawerBig
    );
  }, [openValues, openAdditionalValues]);

  const totalComputer = useMemo(() => {
    return openValues?.Computer + openAdditionalValues?.Computer;
  }, [openValues, openAdditionalValues]);
  // const totalAriesStand = useMemo(() => {
  //   return openAdditionalValues?.AriesStand;
  // }, [openAdditionalValues]);
  // const totalStant =
  let setUpFee = useMemo(() => {
    return (
      totalKiozzkCount * equipmentPrice?.Kiozzk +
      totalSmartCheckout * equipmentPrice?.SmartCheckout +
      totalReceiptPrinter * equipmentPrice?.ReceiptPrinter +
      totalCashDrawer * equipmentPrice?.CashdrawerBig
      // totalAriesStand * equipmentPrice?.AriesStand
    );
  }, [
    totalKiozzkCount,
    totalSmartCheckout,
    totalReceiptPrinter,
    totalCashDrawer,
    // totalAriesStand,
    equipmentPrice,
  ]);

  let discountOnSetupFee = false;

  if (setUpFee >= qualifyingEquipmentPrice) {
    discountOnSetupFee = true;
  }

  let monthlyFee = 0;
  let discountOnMonthlyFee = false;
  let planType = "";
  let uzeliPlan = "";

  // PRICING DECISION — a customer-supplied tablet runs Uzeli check-in, so it
  // occupies a device slot exactly as a customer-supplied Computer does and
  // counts toward the plan tier. A merchant's own payment terminal is NOT
  // counted: it is not running Uzeli, which is the whole reason it cannot show
  // line items or collect tips. Move `totalOwnTerminal` into this sum if that
  // reading is wrong — it is the only line that needs to change.
  //
  // Both sources are summed, matching every other item (Kiozzk, Computer, the cash
  // drawers). Reading only `openValues` meant a customer-supplied device added on the
  // Additional Equipments page was silently dropped: the incrementor moved, the cart
  // total did not, and for the tablet the plan tier would have been understated too.
  const totalOwnTablet =
    (Number(openValues?.OwnTablet) || 0) +
    (Number(openAdditionalValues?.OwnTablet) || 0);
  const totalOwnTerminal =
    (Number(openValues?.OwnTerminal) || 0) +
    (Number(openAdditionalValues?.OwnTerminal) || 0);
  const deviceCount =
    totalKiozzkCount + totalComputer + totalSmartCheckout + totalOwnTablet;

  ({ monthlyFee, planType, uzeliPlan } = getPlanForDevices({
    deviceCount,
    totalSmartCheckout,
    totalKiozzkCount,
    totalComputer,
  }));

  planType =
    planType +
    (openAdditionalValues.MobileApp ? " + Mobile App ($50)" : "") +
    (openAdditionalValues.Website ? " + Website ($50)" : "") +
    (openAdditionalValues.EmailMarketing ? " + Email Marketing ($19)" : "");

  // The SMS tiers (99/139/169/189/199) are the plan ladder above, before any
  // add-on is priced in, so the quota has to be read off the plan alone.
  const basePlanFee = monthlyFee;

  monthlyFee =
    monthlyFee +
    (openAdditionalValues.MobileApp ? equipmentPrice.MobileApp : 0) +
    (openAdditionalValues.Website ? equipmentPrice.Website : 0) +
    (openAdditionalValues.EmailMarketing ? equipmentPrice.EmailMarketing : 0);

  if (monthlyFee >= qualifyingPlanPrice) {
    discountOnMonthlyFee = true;
  }

  // Derive the SMS quota from the plan, but only as a default: a quota that
  // came from Proma is the negotiated value and always wins. This has to sit
  // below the plan ladder — `basePlanFee` is block-scoped, so referencing it
  // from an effect declared earlier in the body throws on every render.
  useEffect(() => {
    if (promaSMSQuotaRef.current) return;
    setMonthlySMSQuota(monthlySMSQuotaFunction(basePlanFee) ?? 0);
  }, [basePlanFee]);

  const { getItems } = useItems();

  useEffect(() => {
    const e = async () => {
      const items = await getItems();
      // console.log({ items });
      setItems(items);
    };
    e();
  }, []);
  // console.log({ uzeliItems });
  const getItemByName = (text) => _.find(uzeliItems, (e) => e.name === text);
  const formattedItem = () =>
    uzeliItems.length
      ? [
          {
            ROWID: getItemByName("Growthzilla Kiozzk").ROWID,
            name: "Growthzilla Kiozzk",
            quantity: totalKiozzkCount,
            unitPrice:
              equipmentPrice.Kiozzk ||
              getItemByName("Growthzilla Kiozzk").unitPrice,
          },
          {
            ROWID: getItemByName("Growthzilla Cloud Receipt Printer").ROWID,
            name: "Growthzilla Cloud Receipt Printer",
            quantity: totalReceiptPrinter,
            unitPrice:
              equipmentPrice.ReceiptPrinter ||
              getItemByName("Growthzilla Cloud Receipt Printer").unitPrice,
          },
          {
            ROWID: getItemByName("Smart Checkout").ROWID,
            name: "Smart Checkout",
            quantity: totalSmartCheckout,
            unitPrice:
              equipmentPrice.SmartCheckout ||
              getItemByName("Smart Checkout").unitPrice,
          },
          {
            ROWID: getItemByName('Cash Drawer Big(16")').ROWID,
            name: 'Cash Drawer Big(16")',
            quantity:
              openValues.CashdrawerBig + openAdditionalValues.CashdrawerBig,
            unitPrice:
              equipmentPrice.CashdrawerBig ||
              getItemByName('Cash Drawer Big(16")').unitPrice,
          },
          {
            ROWID: getItemByName('Cash Drawer Small(13")').ROWID,
            name: 'Cash Drawer Small(13")',
            quantity:
              openValues.CashdrawerSmall + openAdditionalValues.CashdrawerSmall,
            unitPrice:
              equipmentPrice.CashdrawerSmall ||
              getItemByName('Cash Drawer Small(13")').unitPrice,
          },
          {
            ROWID: getItemByName("Computer").ROWID,
            name: "Computer",
            quantity: openValues.Computer + openAdditionalValues.Computer,
            unitPrice: getItemByName("Computer").unitPrice,
          },
          {
            ROWID: getItemByName("Aries8/Aries6 Stand").ROWID,
            name: "Aries Stand",
            quantity: openValues.AriesStand + openAdditionalValues.AriesStand,
            unitPrice: getItemByName("Aries8/Aries6 Stand").unitPrice,
          },
          // Customer-supplied hardware. Optional chaining on purpose: every
          // entry above throws if its UzeliItems row is missing, and these two
          // rows have to be created by hand. A missing row here degrades to an
          // undefined ROWID instead of taking down the whole page.
          {
            ROWID: getItemByName("Own Tablet")?.ROWID,
            name: "Own Tablet",
            quantity: totalOwnTablet,
            unitPrice: getItemByName("Own Tablet")?.unitPrice ?? 0,
          },
          {
            ROWID: getItemByName("Own Terminal")?.ROWID,
            name: "Own Terminal",
            quantity: totalOwnTerminal,
            unitPrice: getItemByName("Own Terminal")?.unitPrice ?? 0,
          },
        ]
      : [];

  // console.log({ formattedItem });
  const _equipment = {
    "Growthzilla Kiozzk Tablet": totalKiozzkCount,
    Computer: openValues?.Computer + openAdditionalValues?.Computer,
    "Pax Aries 8 Checkout Terminal with Stand": totalSmartCheckout,
    "Growthzilla Cloud Receipt Printer": totalReceiptPrinter,
    "Small CashDrawer":
      openValues?.CashdrawerSmall + openAdditionalValues?.CashdrawerSmall,
    "Large CashDrawer":
      openValues?.CashdrawerBig + openAdditionalValues?.CashdrawerBig,
    "Aries Stand": openAdditionalValues?.AriesStand,
    "Own Tablet": totalOwnTablet,
    "Own Terminal": totalOwnTerminal,
  };

  const equipment = _.omitBy(_equipment, (e) => e === 0);

  const isOutOfStock = (productName) => {
    return (
      uzeliItems?.find((item) => item.name === productName)
        ?.sellableQuantity === 0
    );
  };

  // Proma can spell the same product more than one way, so each entry lists
  // every cart key that maps onto one selection. The first unit becomes the
  // primary selection (pages 1-5) and the remainder becomes additional
  // equipment (page 6).
  //
  // `exclusiveWith` mirrors the pages: SecondPage disables Kiozzk when Computer
  // is on and vice versa, and FifthPage does the same for the two cash drawers.
  // A recommendation must not produce a primary pair the UI forbids.
  const CART_TO_FIELD = [
    { field: "Kiozzk", keys: ["Growthzilla Kiozzk Tablet"] },
    {
      field: "SmartCheckout",
      keys: [
        "Pax Aries 8 Checkout Terminal with Stand",
        "Pax Aries 8 Checkout Terminal",
      ],
    },
    { field: "ReceiptPrinter", keys: ["Growthzilla Cloud Receipt Printer"] },
    { field: "Computer", keys: ["Computer"], exclusiveWith: "Kiozzk" },
    { field: "CashdrawerSmall", keys: ["Small CashDrawer"] },
    {
      field: "CashdrawerBig",
      keys: ["Large CashDrawer"],
      exclusiveWith: "CashdrawerSmall",
    },
    { field: "OwnTablet", keys: ["Own Tablet"] },
    { field: "OwnTerminal", keys: ["Own Terminal"] },
  ];

  // Products Proma may still recommend that are no longer sold separately. The
  // terminal now ships as "Pax Aries 8 Checkout Terminal with Stand", so a
  // recommended stand is discarded rather than added to the order. Listed
  // explicitly so this reads as a decision, not an omission from the table
  // above — adding one back would reintroduce a line nothing in the UI can
  // remove. See the AriesStand effect, which clears stands left on saved
  // sessions for the same reason.
  // Discarded from any recommendation.
  //
  // The stand is no longer sold separately — the terminal ships as
  // "... with Stand". "Own Tablet" and "Own Terminal" are the customer telling
  // us they already have the hardware, which is never something a recommended
  // cart should switch on for them: alongside a recommended Kiozzk or Smart
  // Checkout the order would assert both at once, and Own Tablet additionally
  // counts toward deviceCount, so accepting a recommendation could quietly move
  // the customer up a plan tier.
  const RETIRED_CART_KEYS = ["Aries Stand", "Aries8/Aries6 Stand"];

  const CART_TO_FLAG = [
    { field: "MobileApp", keys: ["Mobile App"] },
    { field: "Website", keys: ["Website"] },
    { field: "EmailMarketing", keys: ["Email Marketing"] },
  ];

  const populateCartItems = () => {
    const cart = { ...initialCartItems };
    RETIRED_CART_KEYS.forEach((key) => delete cart[key]);
    // Accepting a recommendation replaces the selection rather than adding to
    // it. Building on the current values meant anything already switched on
    // survived alongside the recommended cart, so the order came out as the
    // union of the two and the customer was charged for both.
    const nextOpen = { ...EMPTY_VALUES };
    const nextAdditional = { ...EMPTY_ADDITIONAL_VALUES };

    // Totals are summed across spellings first. The old code decremented the
    // count in place per branch and, for "Pax Aries 8 Checkout Terminal",
    // decremented the *other* key — so the unit moved into the primary slot was
    // never removed from the remainder and every such order gained a terminal.
    const totals = {};
    CART_TO_FIELD.forEach(({ field, keys }) => {
      totals[field] = keys.reduce(
        (sum, key) => sum + (Number(cart[key]) || 0),
        0
      );
    });

    CART_TO_FIELD.forEach(({ field, exclusiveWith }) => {
      const total = totals[field];
      if (total <= 0) return;
      if (exclusiveWith && totals[exclusiveWith] > 0) {
        nextAdditional[field] = total;
        return;
      }
      nextOpen[field] = 1;
      nextAdditional[field] = total - 1;
    });

    CART_TO_FLAG.forEach(({ field, keys }) => {
      if (keys.some((key) => cart[key] === true || Number(cart[key]) >= 1)) {
        nextAdditional[field] = true;
      }
    });

    saveItemsToSession(`values-${currentUser && currentUser?.id}`, {
      openValues: nextOpen,
      openAdditionalValues: nextAdditional,
    });
    setValues(nextOpen);
    setAdditionalValues(nextAdditional);
    saveItemsToSession("checkout", true);
  };

  const acceptRecommendedCart = () => {
    populateCartItems();
    setCurrentPage(7);
  };

  const rejectRecommendedCart = () => {};

  const isUpperLimitReached = (productName) => {
    const sellableQuantity = uzeliItems?.find(
      (item) => item.name === productName
    )?.sellableQuantity;
    const currentQuantity = formattedItem().find(
      (item) => item.name === productName
    ).quantity;

    return currentQuantity === sellableQuantity || currentQuantity === 8;
  };

  return {
    minimumForInstallments,
    installments,
    openValues,
    openAdditionalValues,
    setValues,
    setAdditionalValues,
    toggleSwitch,
    enable,
    disable,
    currentPage,
    incrementPage,
    decrementPage,
    setUpFee,
    discountOnSetupFee,
    qualifyingEquipmentPrice,
    equipDiscount,
    equipDiscountType,
    monthlyFee,
    discountOnMonthlyFee,
    qualifyingPlanPrice,
    planType,
    formattedItem,
    equipment,
    uzeliPlan,
    totalSmartCheckout,
    equipmentPrice,
    equipmentsFilledFromOrder,
    planPermDiscount,
    planTempDiscount,
    tempDiscountExpiryDate,
    monthlySMSQuota,
    priceAdd1KSMS,
    growthzillaSignee,
    uzeliItems,
    isOutOfStock,
    isUpperLimitReached,
    setCurrentPage,
    invalidLeadInfo,
    initialCartItems,
    acceptRecommendedCart,
    rejectRecommendedCart,
    salesAgent,
    gettingLeadInfo,
    businessNameFromLeadInfo,
    leadIdFromInfo,
    uzeliOrderFromDb,
    setOldOrderToState,
    oldOrderToState,
  };
};

export default useDeviceCounter;
